import { authenticatedGet, authenticatedPost, authenticatedPut, authenticatedDelete } from '../utils/apiUtils';
import { PLEDGES_URL, CHARITIES_URL, USERS_URL } from '../api-config';

export const getPledges = () => authenticatedGet(`${PLEDGES_URL}?all=true`);

export const getPledgeById = (pledgeId) => authenticatedGet(`${PLEDGES_URL}/${pledgeId}`);

export const getPledgesByUserId = async (userId) => {
  const response = await authenticatedGet(`${USERS_URL}/${userId}/pledges`);
  return {
    user: response.user || null,
    pledges: response.pledges || []
  };
};

export const getPledgesByCharityId = async (charityId) => {
  const response = await authenticatedGet(`${CHARITIES_URL}/${charityId}/pledges?all=true`);
  return {
    charity: response.charity || null,
    pledges: response.pledges || []
  };
};

export const createPledge = (pledgeData) => {
  console.log('Creating pledge with data:', pledgeData);
  return authenticatedPost(`${PLEDGES_URL}/for-user/`, pledgeData);
};

export const updatePledge = (pledgeId, pledgeData) => authenticatedPut(`${PLEDGES_URL}/${pledgeId}`, pledgeData);

export const deletePledge = (pledgeId) => authenticatedDelete(`${PLEDGES_URL}/${pledgeId}`);

export const addCheckin = (pledgeId, checkinData) => authenticatedPost(`${PLEDGES_URL}/${pledgeId}/checkin`, checkinData);

export const deleteCheckin = (pledgeId, checkinTimestamp) => {
  const endpoint = `${PLEDGES_URL}/${pledgeId}/checkin`;
  const body = { checkin: checkinTimestamp };
  console.log('🔥 DELETE CHECKIN API CALL:', { endpoint, body: JSON.stringify(body) });
  return authenticatedDelete(endpoint, body);
};